import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginComponent } from '../../login/login.component';

@Component({
  selector: 'app-buyer-verification-page',
  standalone: true,
  imports: [CommonModule, LoginComponent],
  template: `
    <div class="min-h-screen flex items-center justify-center bg-black bg-opacity-40 p-4">
      <app-login
        [verificationOnly]="true"
        (loginSuccess)="onComplete()"
        (verificationComplete)="onComplete()"
      ></app-login>
    </div>
  `,
})
export class BuyerVerificationPageComponent {
  constructor(private router: Router) {}

  onComplete(): void {
    this.router.navigate(['/home']);
  }
}
